import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

export default function ProfileHero({ name, dateRange, biography, mode = 'view' }) {
  const isEditMode = mode === 'edit';

  return (
    <Box
      sx={{
        width: '100%',
        textAlign: 'center',
        py: isEditMode ? { xs: 2, md: 3 } : { xs: 3, md: 5 },
        px: { xs: 2, md: 4 },
      }}
    >
      <Stack direction="row" justifyContent="center" sx={{ mb: 2 }}>
        <Chip
          icon={<FavoriteBorderIcon />}
          label={isEditMode ? 'Úprava spomienkového profilu' : 'Spomienkový profil'}
          sx={{
            borderRadius: 999,
            background: 'rgba(112, 157, 179, 0.14)',
            color: '#2f4e5e',
            fontWeight: 700,
            px: 1,
          }}
        />
      </Stack>
      <Typography
        variant="h2"
        component="h1"
        sx={{
          fontWeight: 700,
          color: '#132838',
          letterSpacing: '-0.03em',
          fontSize: isEditMode
            ? { xs: '2rem', sm: '2.55rem', md: '3rem' }
            : { xs: '2.25rem', sm: '3rem', md: '3.75rem' },
          lineHeight: 1.05,
        }}
      >
        {name || 'Bez mena'}
      </Typography>
      {dateRange && (
        <Typography
          variant="h5"
          component="p"
          sx={{ mt: 1.5, color: '#2f4e5e', fontWeight: 500, fontSize: { xs: '1.15rem', md: '1.4rem' } }}
        >
          {dateRange}
        </Typography>
      )}
      {!isEditMode && biography && (
        <Typography
          variant="body1"
          sx={{
            mt: { xs: 2.5, md: 3.5 },
            mx: 'auto',
            maxWidth: 980,
            color: '#40596a',
            fontSize: { xs: '1.03rem', md: '1.12rem' },
            fontWeight: 500,
            lineHeight: 1.95,
            whiteSpace: 'pre-line',
          }}
        >
          {biography}
        </Typography>
      )}
    </Box>
  );
}
